import { action, observable, computed } from 'mobx';
import { setter } from 'mobx-decorators';
import agent from '../../services/web/agent';

class PermissionsStore {

    @setter @observable permissions = [];

    @action getAllPermissions() {

        return agent.Permissions.getAllPermissions()
            .then(action((permissions) => {
                    
                this.permissions = permissions;
            }));
    }

    @action resetPermissions() {

        this.permissions = [];
    }

    getPermissionIdByName = async (permission) => {
        if (this.permissions.length === 0){
            await this.getAllPermissions();
        }

        return this.permissions.filter(p => p.name === permission)[0].id;
    }
}

export default new PermissionsStore();


// WEBPACK FOOTER //
// ./src/stores/permissions/index.js